import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import StatsRow from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/StatsRow'
import type { Cycle } from 'modules/timeoff/store/models/AllowanceStat'
import type AllowanceStat from 'modules/timeoff/store/models/AllowanceStat'

import BalanceTooltip from './BalanceTooltip'

interface Props {
  selectedStat: AllowanceStat
  selectedCycle: Cycle
  nextCycle: Cycle | null | undefined
}

const Balance = ({ selectedStat, selectedCycle, nextCycle }: Props) => {
  const stat = selectedStat.toJS()
  const usedDays = stat.used_days
  const availableDays = stat.available_days
  let proratedDays = stat.prorated_allowance_days

  const totalAdjustment = stat.incidences
  const totalCarryover = stat.accumulated_carry_over
  const advance = availableDays < 0 ? availableDays : 0

  if (usedDays > proratedDays) {
    proratedDays = availableDays > 0 ? availableDays : 0
  }

  return (
    <StatsRow
      title={i18n.t('time_off.cycle_balance')}
      amount={availableDays}
      tooltip={
        <BalanceTooltip
          accrued={proratedDays}
          carryOver={totalCarryover}
          incidence={totalAdjustment}
          selectedCycle={selectedCycle}
          nextCycle={nextCycle}
          advance={advance}
        />
      }
    />
  )
}

export default Balance
